import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: '"Titillium Web", Titillium, "Segoe UI", sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 700,
    }
  },
  palette: {
    primary: {
      main: '#1b4995',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f0bc17',
      contrastText: '#1b4995',
    },
  },
  overrides: {
    MuiToolbar: {
        regular: {
          minHeight: '64px',
          '@media (min-width: 600px)': {
            minHeight: '72px',
          },
          '@media (min-width: 960px)': {
            minHeight: '80px',
          },
        },
    },
  }
});

export default theme;
